var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"item"},[_c('div',{staticClass:"name"},[_vm._v("\n            "+_vm._s(_vm.scan_action_prototype.name)+"\n        ")]),_c('div',{staticClass:"barcode"},[_c('barcode',{attrs:{"value":'@@'+_vm.scan_action_prototype.barcode+'@@',"tag":'svg',"options":{
                    background: 'transparent',
                    displayValue: false,
                    format: 'CODE128',
                    width: '5vw',
                    height: '120vh'
                }}},[_vm._v("\n                看見此資訊請通知系統工程師。\n            ")])],1),_c('div',{staticClass:"barcode_name"},[_vm._v("\n            "+_vm._s(_vm.scan_action_prototype.barcode)+"\n        ")])]),_c('div',{staticClass:"divided"})])}
var staticRenderFns = []

export { render, staticRenderFns }